/**
 * News Slider Frontend JavaScript
 */

import { initSwiper } from './swiper-init';


document.addEventListener('DOMContentLoaded', () => {
    console.log("swiper");
    const newsSlider = document.querySelector('#dpi-news-slider');

    if (!newsSlider) return;

    console.log("swiper found");

    initSwiper(newsSlider);
});